/* Infinite Options adds a $1 setup product alongside its actual components.
 * Remove only the explicitly marked setup lines, by stable line-item key.
 */
(() => {
  let pending;
  let failed = false;
  const markers = () => [...document.querySelectorAll('[data-tarett-setup-key]')];
  const sectionTargets = () => [
    { id: 'cart-drawer', target: '#CartDrawer', source: '#CartDrawer' },
    { id: 'cart-icon-bubble', target: '#cart-icon-bubble', source: '.shopify-section' },
    ...['main-cart-items', 'main-cart-footer'].flatMap((id) => {
      const node = document.getElementById(id);
      return node ? [{ id: node.dataset.id, target: id === 'main-cart-footer' ? '#main-cart-footer' : `#${id} .js-contents`, source: id === 'main-cart-footer' ? '#main-cart-footer' : '.js-contents' }] : [];
    }),
  ];

  function showError() {
    failed = true;
    for (const container of document.querySelectorAll('#cart-errors, #CartDrawer-CartErrors')) {
      container.textContent = 'We could not finish preparing your package. Refresh the cart before checkout, or contact us for help.';
      container.setAttribute('role', 'alert');
    }
  }

  function clean() {
    if (pending) return pending;
    const keys = [...new Set(markers().map((node) => node.dataset.tarettSetupKey))];
    if (!keys.length) return Promise.resolve();
    document.documentElement.classList.add('tarett-cart-cleaning');
    const targets = sectionTargets();
    const sectionIds = [...new Set(targets.map((target) => target.id).filter(Boolean))];
    pending = fetch(`${window.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: Object.fromEntries(keys.map((key) => [key, 0])),
        sections: sectionIds,
        sections_url: window.location.pathname,
      }),
    }).then(async (response) => {
      if (!response.ok) throw new Error('Package cleanup failed');
      const cart = await response.json();
      if (cart.items.some((item) => keys.includes(item.key))) throw new Error('Setup line remains');
      for (const target of targets) {
        const existing = document.querySelector(target.target);
        if (!existing) continue;
        const markup = cart.sections?.[target.id];
        const replacement = markup && new DOMParser().parseFromString(markup, 'text/html').querySelector(target.source);
        if (!replacement) {
          // The cart is clean; a full render is safer than showing stale totals.
          window.location.reload();
          return;
        }
        existing.innerHTML = replacement.innerHTML;
      }
      const drawer = document.querySelector('cart-drawer');
      drawer?.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
      drawer?.classList.toggle('is-empty', cart.item_count === 0);
      document.querySelector('cart-items')?.classList.toggle('is-empty', cart.item_count === 0);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cart.item_count === 0);
      failed = false;
    }).catch(showError).finally(() => {
      pending = null;
      if (!failed) {
        document.documentElement.classList.remove('tarett-cart-cleaning');
        if (markers().length) clean();
      }
    });
    return pending;
  }

  // Cart section replacements can introduce another package setup line.
  new MutationObserver(() => {
    if (!failed && markers().length) clean();
  }).observe(document.body, { childList: true, subtree: true });

  // Prevent checkout from racing cleanup, including native form submission.
  const guardCheckout = (event) => {
    const button = event.submitter || event.target.closest?.('[name="checkout"], a[href^="/checkout"]');
    if (!button || (!markers().length && !pending && !failed)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    failed = false;
    clean().then(() => {
      if (!failed && !markers().length) window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
    });
  };
  document.addEventListener('click', guardCheckout, true);
  document.addEventListener('submit', guardCheckout, true);
  clean();
})();
